import pages from "./marketing-pages.json";
// WHY: explicit sales-page visits must not depend on login state. Keep default
// root and all workspace/auth/confirmation hashes with the existing app.
// The keyword homepage is public with or without a saved login. Never redirect
// the bare root: hash-only workspace and confirmation links use that same URL.
export function publicMarketingRequested(pathname: string, hash: string): boolean {
  if (hash === "#create-account" || hash === "#sign-in" || hash.startsWith("#confirm")) return false;
  const slug = pathname.replace(/^\//, "").replace(/\/+$/, "");
  return slug === "ai-assistant-for-business" || pages.some(page => page.slug === slug) || (pathname === "/" && hash.startsWith("#landing-"));
}
